import React from 'react';
import { X_ICON_PATH } from '../../constants/milletSocialLinks';

/**
 * X (Twitter) glyph for Millet social links.
 * @param {Object} props
 * @param {number} [props.size=20] - Width/height in px
 * @param {string} [props.className]
 */
function XIcon({ size = 20, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size, display: 'block', flexShrink: 0 }}
    >
      <path d={X_ICON_PATH} fill="currentColor" />
    </svg>
  );
}

export default XIcon;
